module.exports = __webpack_public_path__ + "img/JP.583e8aab.svg";